import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {
  AuthGuardService,
  MonekAdminGuardService,
  VirtualTerminalGuardService,
  PartnerGuardService,
  PEBLGuardService,
  ElevatedMfaGuardService,
  ReportsGuardService
} from '@odin/odin-authentication';
import { DashboardComponent } from './dashboard-page/dashboard.component';
import { ErrorPageComponent } from './error-page/error-page.component';
import { VirtualTerminalPageComponent } from './virtual-terminal-page/virtual-terminal-page.component';
import { PeblPageComponent } from './pebl-page/pebl-page.component';
import { TransactionOutcomePageComponent } from './transaction-outcome-page/transaction-outcome-page.component';
import { PeblTrackingPageComponent } from '@odin/odin-transactions';
import { TransactionCryptoPageComponent } from './transaction-crypto-page/transaction-crypto-page.component';
import { NotificationsPageComponent } from './pages/notifications-page/notifications-page.component';

const routes: Routes = [
  // Non auth pages
  { path: '', pathMatch: 'full', redirectTo: '/authentication/login' },
  {
    path: 'transaction-status/:status',
    component: TransactionOutcomePageComponent,
  },

  // Package routing
  {
    path: 'admin',
    loadChildren: () =>
      import('@odin/odin-admin').then((m) => m.OdinAdminModule),
    canActivate: [AuthGuardService],
  },
  {
    path: 'authentication',
    loadChildren: () =>
      import('@odin/odin-authentication').then(
        (m) => m.OdinAuthenticationModule,
      ),
  },
  {
    path: 'transactions',
    loadChildren: () =>
      import('@odin/odin-transactions').then((m) => m.OdinTransactionsModule),
    canActivate: [AuthGuardService],
  },
  {
    path: 'reports',
    loadChildren: () =>
      import('@odin/odin-reports').then((m) => m.odinReportsRoutes),
    canActivate: [AuthGuardService, ReportsGuardService],
  },
  {
    path: 'crypto-transactions',
    component: TransactionCryptoPageComponent,
    canActivate: [AuthGuardService],
  },
  {
    // Must precede 'settings' so the two-segment path matches before the settings module's children
    path: 'settings/integrations',
    loadChildren: () =>
      import('@odin/odin-integrations').then((m) => m.OdinIntegrationsModule),
    canActivate: [AuthGuardService],
  },
  {
    path: 'settings',
    loadChildren: () =>
      import('@odin/odin-settings').then((m) => m.OdinSettingsModule),
    canActivate: [AuthGuardService],
  },
  {
    path: 'monek-admin',
    loadChildren: () =>
      import('@odin/odin-monek-admin').then((m) => m.OdinMonekAdminModule),
    canActivate: [AuthGuardService, MonekAdminGuardService],
  },
  {
    path: 'partner',
    loadChildren: () =>
      import('@odin/odin-partner').then(m => m.OdinPartnersModule),
    canActivate: [AuthGuardService, PartnerGuardService],
  },

  // UI pages
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'notifications',
    component: NotificationsPageComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'virtual-terminal/VT',
    component: VirtualTerminalPageComponent,
    canActivate: [AuthGuardService, VirtualTerminalGuardService],
  },
  {
    path: 'virtual-terminal/PEBL',
    component: PeblPageComponent,
    canActivate: [AuthGuardService, PEBLGuardService],
  },
  {
    path: 'virtual-terminal/PEBL-tracking',
    component: PeblTrackingPageComponent,
    canActivate: [AuthGuardService],
  },
  // Legacy integrations paths now live under settings
  { path: 'integrations', redirectTo: 'settings/integrations' },
  { path: 'integrations/xero', redirectTo: 'settings/integrations/xero' },
  { path: 'integrations/xero/:tenantId', redirectTo: 'settings/integrations/xero/:tenantId' },
  // Error handling
  { path: '**', component: ErrorPageComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [
    AuthGuardService,
    MonekAdminGuardService,
    PartnerGuardService,
    VirtualTerminalGuardService,
    PEBLGuardService,
    ElevatedMfaGuardService,
    ReportsGuardService
  ],
})
export class AppRoutingModule {}
